export default "__VITE_ASSET__CfSJJ1qG__"